/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  MrfiktivBatchImportPersonDtoGen,
  MrfiktivBatchImportResultViewModelGen,
  MrfiktivCreatePersonDtoGen,
  MrfiktivMultipleIdsDtoGen,
  MrfiktivPageViewModelGen,
  MrfiktivPersonControllerBatchImportParamsGen,
  MrfiktivPersonControllerGetParamsGen,
  MrfiktivPersonViewModelGen,
  MrfiktivUpdatePersonDtoGen
} from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class Person<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * No description
   *
   * @tags person
   * @name PersonControllerCreate
   * @summary (Person - CREATE) Create a Person
   * @request POST:/partner/{partnerId}/person
   * @secure
   * @response `201` `MrfiktivPersonViewModelGen` The created person
   */
  personControllerCreate = (partnerId: string, data: MrfiktivCreatePersonDtoGen, params: RequestParams = {}) =>
    this.http.request<MrfiktivPersonViewModelGen, any>({
      path: `/partner/${partnerId}/person`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags person
   * @name PersonControllerGet
   * @summary (Person - READ) Get all companies
   * @request GET:/partner/{partnerId}/person
   * @secure
   * @response `200` `(MrfiktivPageViewModelGen & { data?: (MrfiktivPersonViewModelGen)[] })`
   */
  personControllerGet = ({ partnerId, ...query }: MrfiktivPersonControllerGetParamsGen, params: RequestParams = {}) =>
    this.http.request<MrfiktivPageViewModelGen & { data?: MrfiktivPersonViewModelGen[] }, any>({
      path: `/partner/${partnerId}/person`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params
    });
  /**
   * @description Imports multiple persons in a single request with upsert behavior based on externalId. **Matching Logic:** - Existing persons are matched by `externalId` (normalized by removing whitespace) - If `externalId` is provided and matches an existing person, that person is updated - If `externalId` is provided but no match is found, a new person is created - If no `externalId` is provided, a new person is always created **Normalization:** - The `externalId` is normalized by removing all whitespace before matching and saving - Example: `"EXT 001"` and `"EXT001"` are treated as the same externalId **Validation:** - By default, the batch is validated to ensure no duplicate `externalId` values exist within the batch - Use `skipDuplicateCheck=true` to bypass this validation **Error Cases:** - `DUPLICATE_EXTERNAL_IDS_IN_BATCH`: Multiple persons in the batch have the same externalId (after normalization)
   *
   * @tags person
   * @name PersonControllerBatchImport
   * @summary (Person - CREATE) Batch import persons with upsert by externalId
   * @request POST:/partner/{partnerId}/person/batch
   * @secure
   * @response `201` `MrfiktivBatchImportResultViewModelGen` The batch import result
   * @response `400` `void` Validation failed due to duplicate externalIds in batch
   */
  personControllerBatchImport = (
    { partnerId, ...query }: MrfiktivPersonControllerBatchImportParamsGen,
    data: MrfiktivBatchImportPersonDtoGen,
    params: RequestParams = {}
  ) =>
    this.http.request<MrfiktivBatchImportResultViewModelGen, void>({
      path: `/partner/${partnerId}/person/batch`,
      method: "POST",
      query: query,
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags person
   * @name PersonControllerGetMany
   * @summary (Company - READ) Get many person
   * @request POST:/partner/{partnerId}/person/getByIds
   * @secure
   * @response `200` `(MrfiktivPersonViewModelGen)[]` The persons
   */
  personControllerGetMany = (partnerId: string, data: MrfiktivMultipleIdsDtoGen, params: RequestParams = {}) =>
    this.http.request<MrfiktivPersonViewModelGen[], any>({
      path: `/partner/${partnerId}/person/getByIds`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags person
   * @name PersonControllerGetOne
   * @summary (Person - READ) Get a person
   * @request GET:/partner/{partnerId}/person/{personId}
   * @secure
   * @response `200` `MrfiktivPersonViewModelGen` The person
   */
  personControllerGetOne = (partnerId: string, personId: string, params: RequestParams = {}) =>
    this.http.request<MrfiktivPersonViewModelGen, any>({
      path: `/partner/${partnerId}/person/${personId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags person
   * @name PersonControllerUpdate
   * @summary (Person - UPDATE) Updates a person
   * @request PATCH:/partner/{partnerId}/person/{personId}
   * @secure
   * @response `201` `MrfiktivPersonViewModelGen` The updated person
   */
  personControllerUpdate = (
    partnerId: string,
    personId: string,
    data: MrfiktivUpdatePersonDtoGen,
    params: RequestParams = {}
  ) =>
    this.http.request<MrfiktivPersonViewModelGen, any>({
      path: `/partner/${partnerId}/person/${personId}`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags person
   * @name PersonControllerDelete
   * @summary (Person - DELETE) Deletes a person
   * @request DELETE:/partner/{partnerId}/person/{personId}
   * @secure
   * @response `200` `MrfiktivPersonViewModelGen` The deleted person
   */
  personControllerDelete = (partnerId: string, personId: string, params: RequestParams = {}) =>
    this.http.request<MrfiktivPersonViewModelGen, any>({
      path: `/partner/${partnerId}/person/${personId}`,
      method: "DELETE",
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags person
   * @name PersonControllerGetOneByMail
   * @summary (Person - READ) Get a person
   * @request GET:/partner/{partnerId}/person/{mail}/byMail
   * @secure
   * @response `200` `(MrfiktivPersonViewModelGen)[]` The person
   */
  personControllerGetOneByMail = (partnerId: string, mail: string, params: RequestParams = {}) =>
    this.http.request<MrfiktivPersonViewModelGen[], any>({
      path: `/partner/${partnerId}/person/${mail}/byMail`,
      method: "GET",
      secure: true,
      format: "json",
      ...params
    });
}
